<ng-content />

<div
  class="popover-anchor"
  [style.left.px]="anchorPosition().x"
  [style.top.px]="anchorPosition().y"
  [style.width.px]="anchorPosition().width"
  [style.height.px]="anchorPosition().height"
  [matMenuTriggerFor]="menu"
  #trigger="matMenuTrigger"
></div>

<mat-menu #menu="matMenu" [hasBackdrop]="false" class="study-notes-popover-panel">
  <div
    class="popover-content-wrapper"
    (mouseenter)="onPopoverMouseEnter()"
    (mouseleave)="onPopoverMouseLeave()"
    (click)="$event.stopPropagation()"
  >
    <div class="popover-body">
      <ng-container *ngComponentOutlet="contentRenderer(); inputs: { blocks: popoverContent() }" />
      @if (popoverLinkUrl()) {
        @if (isExternalLink()) {
          <a [href]="popoverLinkUrl()" target="_blank" rel="noopener noreferrer" (click)="hidePopover()">
            <ng-container *ngTemplateOutlet="learnMoreButton" />
          </a>
        } @else {
          <a [routerLink]="popoverLinkUrl()" (click)="hidePopover()">
            <ng-container *ngTemplateOutlet="learnMoreButton" />
          </a>
        }
      }
    </div>
  </div>
</mat-menu>

<ng-template #learnMoreButton>
  <dojo-button class="w-full">
    {{ 'examdojo.learn_more' | transloco }}
  </dojo-button>
</ng-template>
